import { DragDropProvider, useDroppable } from '@dnd-kit/react';
import { useSortable } from '@dnd-kit/react/sortable';

export function Draggable({ id, index, group, children }) {
    const { ref, handleRef, isDragging, isDropTarget } = useSortable({
        id: id.toString(),
        index,
        group: group?.toString()
    });
    const provided = {
        innerRef: ref,
        draggableProps: { 'data-dnd-kit-sortable': id },
        dragHandleProps: { ref: handleRef, style: { cursor: 'grab' }, 'data-dnd-kit-drag-handle': id }
    };
    const snapshot = { isDragging, isDropTarget };
    return children(provided, snapshot);
}

export function Droppable({ id, children }) {
    const { ref, isDropTarget } = useDroppable({ id: id.toString() });
    const provided = {
        innerRef: ref,
        droppableProps: { 'data-dnd-kit-droppable': id },
        placeholder: null
    };
    const snapshot = { isDropTarget };
    return children(provided, snapshot);
}

export function DragDropContext({ children, onDragEnd, onDragStart }) {
    return (
        <DragDropProvider
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onDragOver={event => {
                const { source, target } = event.operation;
                if (!target) return;

                const sourceGroup = source.sortable?.initialGroup;
                const targetGroup = target.sortable?.group || target.sortable?.initialGroup;

                // When transitioning between distinct containers, intercept the event
                if (sourceGroup !== targetGroup) {
                    event.preventDefault();
                }
            }}
        >
            {children}
        </DragDropProvider>
    );
}
